var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOccasionTrauungLow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1024,
    height: 1024,
    fill: "#9a7c5b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(4.000000) translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    fillOpacity: 0.501961,
    points: "171,182 190,24 33,136"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "271,145 271,224 25,205"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f4ffff",
    fillOpacity: 0.501961,
    points: "173,182 181,65 60,53"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "231,233 271,82 227,90"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#844b0a",
    fillOpacity: 0.501961,
    points: "165,64 271,-7 -16,5"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#745529",
    fillOpacity: 0.501961,
    points: "85,-14 -16,88 57,218"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#00071f",
    fillOpacity: 0.501961,
    points: "57,201 64,166 187,179"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#eea358",
    fillOpacity: 0.501961,
    points: "193,201 179,49 262,10"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d3e5ee",
    fillOpacity: 0.501961,
    points: "171,177 65,163 76,63"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e79442",
    fillOpacity: 0.501961,
    points: "206,206 22,251 271,271"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e69247",
    fillOpacity: 0.501961,
    points: "12,196 56,144 59,271"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2d0200",
    fillOpacity: 0.501961,
    points: "269,227 202,201 271,37"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#dbd5a5",
    fillOpacity: 0.501961,
    points: "271,170 229,152 228,133"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#636455",
    fillOpacity: 0.501961,
    points: "105,99 -16,155 89,137"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#dba060",
    fillOpacity: 0.501961,
    points: "148,36 221,69 56,51"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fcb066",
    fillOpacity: 0.501961,
    points: "206,220 199,157 183,168"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#eff5fd",
    fillOpacity: 0.501961,
    points: "171,165 185,63 65,156"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#292d31",
    fillOpacity: 0.501961,
    points: "60,160 177,220 77,215"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "197,205 177,206 174,166"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#66411c",
    fillOpacity: 0.501961,
    points: "119,40 203,40 271,-4"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#200000",
    fillOpacity: 0.501961,
    points: "224,221 233,148 199,177"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c5cfd8",
    fillOpacity: 0.501961,
    points: "80,52 63,167 113,58"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d99d5b",
    fillOpacity: 0.501961,
    points: "238,260 174,243 271,214"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#625c44",
    fillOpacity: 0.501961,
    points: "64,144 -6,157 78,56"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "254,81 228,101 271,130"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#6d6e5f",
    fillOpacity: 0.501961,
    points: "242,67 208,102 216,139"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#b87636",
    fillOpacity: 0.501961,
    points: "188,221 46,260 60,211"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#8b5e26",
    fillOpacity: 0.501961,
    points: "34,253 -2,271 -11,141"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#8e6833",
    fillOpacity: 0.501961,
    points: "-16,-5 164,-10 -4,57"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#233d2c",
    fillOpacity: 0.501961,
    points: "125,99 127,88 117,94"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d59656",
    fillOpacity: 0.501961,
    points: "262,19 130,58 268,72"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#280000",
    fillOpacity: 0.501961,
    points: "210,211 271,146 241,225"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d2995f",
    fillOpacity: 0.501961,
    points: "204,197 180,222 235,258"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#343840",
    fillOpacity: 0.501961,
    points: "169,221 174,176 62,176"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e0e8f0",
    fillOpacity: 0.501961,
    points: "182,65 141,104 81,54"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#647c75",
    fillOpacity: 0.501961,
    points: "35,6 22,93 5,64"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#8a9187",
    fillOpacity: 0.501961,
    points: "115,57 96,106 99,72"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c68949",
    fillOpacity: 0.501961,
    points: "84,44 37,61 57,84"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cb8d51",
    fillOpacity: 0.501961,
    points: "42,261 6,171 89,231"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#9a5c26",
    fillOpacity: 0.501961,
    points: "59,197 73,85 41,160"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#526b66",
    fillOpacity: 0.501961,
    points: "86,75 65,70 56,95"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c78b51",
    fillOpacity: 0.501961,
    points: "181,180 181,94 228,146"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#88b0ab",
    fillOpacity: 0.501961,
    points: "37,108 56,119 50,133"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "173,180 197,205 179,213"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#405647",
    fillOpacity: 0.501961,
    points: "87,107 104,102 90,120"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c9cbc8",
    fillOpacity: 0.501961,
    points: "109,137 139,118 74,119"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c78d50",
    fillOpacity: 0.501961,
    points: "8,140 18,84 3,93"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2c0000",
    fillOpacity: 0.501961,
    points: "219,152 271,228 203,171"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c48c52",
    fillOpacity: 0.501961,
    points: "211,261 172,201 163,271"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#b4a27b",
    fillOpacity: 0.501961,
    points: "225,145 251,160 257,152"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d3c8ac",
    fillOpacity: 0.501961,
    points: "64,165 115,155 167,174"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#675c4c",
    fillOpacity: 0.501961,
    points: "38,151 25,82 -12,204"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c1a07b",
    fillOpacity: 0.501961,
    points: "93,40 166,42 142,56"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#704315",
    fillOpacity: 0.501961,
    points: "63,45 33,61 16,47"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#908262",
    fillOpacity: 0.501961,
    points: "269,57 258,81 212,98"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#360000",
    fillOpacity: 0.501961,
    points: "230,224 205,200 246,221"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#7a5124",
    fillOpacity: 0.501961,
    points: "271,-8 172,42 147,7"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#040202",
    fillOpacity: 0.501961,
    points: "171,203 196,197 174,173"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#714312",
    fillOpacity: 0.501961,
    points: "65,28 98,39 59,45"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a97749",
    fillOpacity: 0.501961,
    points: "-9,130 10,170 54,164"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillOpacity: 0.501961,
    points: "226,107 240,89 271,93"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#482f11",
    fillOpacity: 0.501961,
    points: "271,225 267,271 244,258"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#caced2",
    fillOpacity: 0.501961,
    points: "95,100 138,120 108,78"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#363634",
    fillOpacity: 0.501961,
    points: "173,178 61,165 66,213"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#8a6033",
    fillOpacity: 0.501961,
    points: "115,231 167,220 59,208"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#475045",
    fillOpacity: 0.501961,
    points: "80,86 76,97 74,92"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#689089",
    fillOpacity: 0.501961,
    points: "76,208 70,197 72,220"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#383d3a",
    fillOpacity: 0.501961,
    points: "176,166 187,177 177,154"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d79752",
    fillOpacity: 0.501961,
    points: "250,245 227,230 271,211"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cc9255",
    fillOpacity: 0.501961,
    points: "222,224 189,183 203,220"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#b67331",
    fillOpacity: 0.501961,
    points: "28,72 37,111 46,68"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ce9357",
    fillOpacity: 0.501961,
    points: "182,47 198,189 225,34"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#678987",
    fillOpacity: 0.501961,
    points: "36,63 21,63 6,97"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#9fb7b6",
    fillOpacity: 0.501961,
    points: "178,167 181,177 188,181"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#082e36",
    fillOpacity: 0.501961,
    points: "4,105 -12,104 0,125"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a97842",
    fillOpacity: 0.501961,
    points: "60,-16 106,37 61,15"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#b87b41",
    fillOpacity: 0.501961,
    points: "183,75 202,80 177,144"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#978768",
    fillOpacity: 0.501961,
    points: "218,95 234,147 214,155"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#8c795b",
    fillOpacity: 0.501961,
    points: "210,120 257,68 222,82"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#124f5a",
    fillOpacity: 0.501961,
    points: "29,96 15,102 24,110"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#6b989d",
    fillOpacity: 0.501961,
    points: "31,133 49,129 38,143"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#080606",
    fillOpacity: 0.501961,
    points: "185,176 181,213 195,203"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#8b9491",
    fillOpacity: 0.501961,
    points: "37,46 56,43 57,33"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#476343",
    fillOpacity: 0.501961,
    points: "78,128 92,131 90,137"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#5e9bb4",
    fillOpacity: 0.501961,
    points: "12,138 19,143 22,133"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d3d4d5",
    fillOpacity: 0.501961,
    points: "74,127 98,94 87,64"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ecf1f4",
    fillOpacity: 0.501961,
    points: "184,67 173,162 126,60"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#37452c",
    fillOpacity: 0.501961,
    points: "83,94 85,97 85,101"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#320200",
    fillOpacity: 0.501961,
    points: "205,166 201,191 251,220"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#b99875",
    fillOpacity: 0.501961,
    points: "6,180 39,258 34,205"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#343516",
    fillOpacity: 0.501961,
    points: "268,160 234,140 241,102"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#363539",
    fillOpacity: 0.501961,
    points: "150,174 168,219 75,210"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#906934",
    fillOpacity: 0.501961,
    points: "22,-16 24,53 -16,41"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#bb7f44",
    fillOpacity: 0.501961,
    points: "23,209 177,231 124,267"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#e1e2e3",
    fillOpacity: 0.501961,
    points: "73,132 74,155 141,163"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a9aca7",
    fillOpacity: 0.501961,
    points: "139,88 122,98 142,96"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#789193",
    fillOpacity: 0.501961,
    points: "77,136 68,146 60,144"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#250000",
    fillOpacity: 0.501961,
    points: "227,150 258,220 255,167"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4b665c",
    fillOpacity: 0.501961,
    points: "78,94 47,80 39,93"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d2985f",
    fillOpacity: 0.501961,
    points: "222,150 195,171 207,120"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOccasionTrauungLow);
export default __webpack_public_path__ + "static/media/occasion_trauung_low.0484922be2dfddd07c97f27be2efa9ca.svg";
export { ForwardRef as ReactComponent };